export type PortfolioCircleAvatarSize = 'sm' | 'md' | 'lg'

export type PortfolioCircleAvatarLocation = {
    imageUrl?: string | null
    name: string
}

export type PortfolioCircleAvatarProps = {
    /** Locations whose images to composite. Only the first 2 images are shown. */
    locations: PortfolioCircleAvatarLocation[]
    /** Letter rendered in the empty-state fallback. Defaults to 'P'. */
    fallbackInitial?: string
    /** Named size token. Defaults to 'md' (matches Home dashboard cards). */
    size?: PortfolioCircleAvatarSize
    /** Merged with default classes. */
    className?: string
}

export const SIZE_MAP: Record<PortfolioCircleAvatarSize, number> = {
    sm: 32,
    md: 36,
    lg: 40,
}
